export const blockIconsEditorMonetizationOn = (
	<span className='material-symbols-outlined'>monetization_on</span>
);
